import axios from 'axios'
import { API_URL } from '../../../../constants'

export const getPaymentMethods = (params?: {}) =>
  axios.get(`${API_URL}/api/payment-method/list?perPage=99&page=1`, {
    params: {
      enabled: true,
      hiddenFromList: false,
    },
  })
